"use strict";

var LKCommon = function () {
  var mask = null;

  function initSelectric($selector) {
    $selector.selectric({
      disableOnMobile: false,
      nativeOnMobile: false
    });
  }

  function initExpandedSelectric($selector) {
    $selector.selectric({
      disableOnMobile: false,
      nativeOnMobile: false,
      expandToItemText: true
    });
  }

  function unbindHandlers() {
    $(document).off('click', '.accordeon-header');
    $(document).off("countrychange", ".input-phone-auth");
  }

  function bindHandlers() {
    $(document).on('click', '.accordeon-header', function () {
      var $accordeon = $(this).parent();
      var isOpen = $accordeon.hasClass('-open');
      var stayOpen = $accordeon.hasClass('-stayOpen');

      if (isOpen) {
        $accordeon.removeClass('-open');
      } else {
        if (!stayOpen) {
          $('.accordeon-item').removeClass('-open');
        }

        $accordeon.addClass('-open');
      }
    });
  }

  function setViewport() {
    if (screen.width < 400) {
      $('#viewport').attr('content', 'width=400, maximum-scale=0.8');
    }
  }

  function openGalleryModal(opts) {
    var $modal = $(opts.modal.selector);
    var $loader = $modal.find('.loader.-local');
    var settings = $.extend(true, {
      modal: {
        title: '',
        size: 'big',
        buttons: [],
        afterOpen: function afterOpen() {
          var $gallery = settings.gallery.selector ? $(settings.gallery.selector) : $modal.find('.slick-gallery');
          $gallery.show();

          if ($gallery.hasClass('slick-initialized')) {
            $gallery.slick('unslick');
          }

          $gallery.slick(settings.slideOpts);

          if (settings.gallery.hasTitle) {
            $gallery.on('afterChange', function () {
              var slideTitle = $('.slick-current').find('li').data('gallery-title');
              var $title = $('.slick-gallery-title');
              $title.text(slideTitle);
            });
          }

          $gallery.css({
            visibility: 'visible'
          });
          $loader.hide();
        }
      },
      gallery: {
        hasTitle: false
      },
      slideOpts: {
        dots: true,
        infinite: false,
        adaptiveHeight: false
      }
    }, opts);
    $loader.show();
    $modal.showAsModal(settings.modal);
  }

  function init() {
    unbindHandlers();
    setViewport();
    bindHandlers();
    initTelMask();
  }

  function initTelMask() {
    $(".input-phone-auth").each(function (i, input) {
      window.intlTelInput(input, {
        autoPlaceholder: "off",
        initialCountry: "ru",
        preferredCountries: ['ru'],
        separateDialCode: true
      });
      var maskOptions = {
        mask: '000 0000000'
      };
      mask = new IMask(input, maskOptions);
      $(document).on("countrychange", input, function () {
        var iti = window.intlTelInputGlobals.getInstance(input);
        var cData = iti.getSelectedCountryData();

        if (cData.iso2 === "ru") {
          maskOptions = {
            mask: '000 0000000'
          };
        } else {
          maskOptions = {
            mask: '0000000000[00]'
          };
        }

        mask.updateOptions(maskOptions);
        mask.value = "";
      });
    });
  }

  return {
    init: init,
    initSelectric: initSelectric,
    initTelMask: initTelMask,
    initExpandedSelectric: initExpandedSelectric,
    openGalleryModal: openGalleryModal
  };
}();

$(document).ready(function () {
  LKCommon.init();
});